import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';
import { Button } from 'react-admin';

const StyledButton = styled(Button)(({ theme }) => ({
    color: theme?.palette?.error?.main || '#d32f2f',
}));

const RemoveImageButton = (props) => {
    const { image, onRemove } = props;

    const handleClick = useCallback(() => {
        onRemove(image);
    }, [onRemove, image]);

    return (
        <StyledButton
            label="Remove image"
            onClick={handleClick}
        >
            <DeleteIcon />
        </StyledButton>
    );
};

RemoveImageButton.propTypes = {
    image: PropTypes.object.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default RemoveImageButton;
